<template>
  <svg class="site-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <path :d="paths[name] || paths['arrow-right']" />
  </svg>
</template>

<script>
const paths = {
  plus: 'M5 12h14M12 5v14',
  minus: 'M5 12h14',
  'arrow-right': 'M5 12h14m-6-6 6 6-6 6',
  'arrow-left': 'M19 12H5m6-6-6 6 6 6',
  'arrow-up': 'M12 19V5m-6 6 6-6 6 6',
  'arrow-down': 'M12 5v14m-6-6 6 6 6-6',
  'arrows-horizontal': 'M4 12h16M8 8l-4 4 4 4m8-8 4 4-4 4',
  'corner-arrow': 'M6 4v11h13m-5-5 5 5-5 5',
  spark: 'M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9',
  check: 'm5 12 4 4L19 6',
  search: 'M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-2 4 6 6',
  monitor: 'M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  refresh: 'M19 8a8 8 0 1 0 1 7M19 3v5h-5',
  document: 'M5 3h14v18H5ZM8 8h8M8 12h8M8 16h5',
  window: 'M3 5h18v14H3ZM3 9h18',
};
export default {
  name: 'SiteIcon',
  props: { name: { type: String, required: true } },
  data: () => ({ paths }),
};
</script>

<style scoped>
.site-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
  vertical-align: -0.12em;
  overflow: visible;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
